import { JSX } from 'solid-js';
import { useProjectDataPanel } from '@trimble/project-data-panel-ui';
import TrajectorySelectionTreeContainer from '../TrajectorySelectionTreeContainer';
import { ProjectDataTreeContainerProps } from './shared-panel.types';
import { TrajectoryItem } from '@mobile-mapping/providers';

export type SharedTrajectoryTreeContainerProps =
  ProjectDataTreeContainerProps<TrajectoryItem>;

export const SharedTrajectoryTreeContainer = (
  props: SharedTrajectoryTreeContainerProps
): JSX.Element => {
  const { filterText, sortBy, sortDirection, filterMode } =
    useProjectDataPanel();

  return (
    <TrajectorySelectionTreeContainer
      nodes={props.nodes}
      childrenLoadStatus={props.childrenLoadStatus}
      filterText={filterText()}
      sortBy={sortBy()}
      sortDirection={sortDirection()}
      filterMode={filterMode()}
    />
  );
};
